import { Routes } from '@angular/router';

export const ROUTES: Routes = [
  {
    path: 'login',
    title: 'Login',
    data: { title: 'Login' },
    loadComponent: () => import('./pages/login/login.component'),
  },
];
